export class OrganizationLevel {
    id: string;
    name: string;
    parentId?: string;
    child?: OrganizationLevel;
    jurisdictionId?: string;
    code?: string;
    orgLevelType?: number;
    children?: OrganizationLevel[];
    sampleNumberTemplate?: string;
    isActive?: boolean;
    defaultPressureMmHg?: number;
    applyTemperatureCorrection?: boolean;
    applyPressureCorrection?: boolean;
    altitudeMeters?: number;
    labRequisitionNumberTemplate?: string;
    enableLabResultExceedanceNotifications?: boolean;
    latitude?: number | null;
    longitude?: number | null;
}
